import { createNamespacedHelpers } from "vuex-composition-helpers";
const {
  useActions,
  useGetters,
  useMutations,
  useState
} = createNamespacedHelpers("AgentStore");
export const useAgentStoreActions = useActions;
export const useAgentStoreGetters = useGetters;
export const useAgentStoreMutations = useMutations;
export const useAgentStoreState = useState;